module.exports = __webpack_public_path__ + "img/spezialisierungen_1280.52f45e1c.png";